import React from "react";
import cx from "classnames";

import "./BreakdownSection.scss";

interface IBreakdownSectionProps {
  isPrintView?: boolean;
}

const BreakdownSection: React.FC<
  React.PropsWithChildren<IBreakdownSectionProps>
> = (props) => (
  <div
    className={cx("c-breakdown-section", {
      "c-breakdown-section--print": props.isPrintView,
    })}
  >
    {props.children}
  </div>
);

export default BreakdownSection;
